import {ListView, ListViewProps, ListViewState} from "./ListView";
import renderText from "../renderText";
import styles from "./list-view.module.css";
import topPanelStyles from "../top-panel/top-panel.module.css";
import {cssHelper} from "../../utils/cssHelper";
import icons from "../../styles/icons.module.css";
import React from "react";
import playSound from "../../sounds/playSound";

export abstract class ListViewScene<TEntry, TProps extends ListViewProps, TState extends ListViewState<TEntry>> extends ListView<TEntry, TProps, TState> {
    render() {
        return (
            <section className={styles.container}>
                <div className={topPanelStyles.top_panel}>
                    <button className={cssHelper(topPanelStyles.back_button, icons.back).toString()}
                            onClick={() => this.back()}>Back
                    </button>

                    {renderText(this.getHeader(), 32, 58, 15, 25, styles.header)}
                </div>

                {super.render()}
            </section>
        );
    }

    protected back() {
        playSound("button-click");
    }

    abstract getHeader(): string;
}